module.exports = __webpack_public_path__ + "static/media/23.46702dc8.jpg";